import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MojoHasPrivilegesGuard } from 'mojo-privileges';

import { CandidateUploadSelectResolver } from './candidate-upload-select.resolver';
import { candidateUploadConfig } from './candidate-upload.config';
import { UploadModalContainerComponent } from './containers';

export const modalRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: ':id',
        component: UploadModalContainerComponent,
        canActivate: [MojoHasPrivilegesGuard],
        data: {
          privileges: [
            candidateUploadConfig.privileges.associate.jobs_to_candidate,
          ],
        },
        resolve: [CandidateUploadSelectResolver],
      },
      {
        path: '',
        component: UploadModalContainerComponent,
        resolve: [CandidateUploadSelectResolver],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(modalRoutes)],
  exports: [RouterModule],
  providers: [CandidateUploadSelectResolver],
})
export class CandidateUploadRoutingModule {}
